import axiosIns from '../../../xaxios';
import { obtenerUrlAPIComisiones } from '../utils/funciones';

export default {
  async findAllSedes(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIComisiones('talento-humano/sedes'), opciones);
  },
};
